<div mat-dialog-content>
  <p>Template name?</p>
  <mat-form-field>
    <input matInput [(ngModel)]="data.name">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button [disabled]="!data.name.length" (click)=" this.dialogRef.close(data.name)" cdkFocusInitial>Save</button>
</div>
